import { Controller } from '@hotwired/stimulus';
import consumer from '../channels/consumer';

// Manages the ActionCable SubscriptionIntentionChannel for the
// payment flow. Uses Stimulus targets instead of getElementById.
//
// Usage (targets are on step_card partials rendered inside
// show.html.erb, controller is on .large-container via
// _new_subscription.html.erb):
//
//   <div data-controller="subscription-intention-channel"
//        data-subscription-intention-channel-intention-id-value="123">
//     <div data-subscription-intention-channel-target="step1">…</div>
//     <div data-subscription-intention-channel-target="step1Failure" class="d-none">…</div>
//     <div data-subscription-intention-channel-target="step1Error" class="d-none">…</div>
//   </div>
export default class SubscriptionIntentionChannelController extends Controller {
  static targets = ['step1', 'step1Failure', 'step1Error'];

  static values = {
    intentionId: Number,
    delay: { type: Number, default: 5000 },
  };

  connect() {
    this.redirectTimer = null;
    this.errorDelayTimer = null;

    this.cableSubscription = consumer.subscriptions.create(
      {
        channel: 'SubscriptionIntentionChannel',
        subscription_intention_id: this.intentionIdValue,
      },
      {
        received: (data) => this.handleReceived(data),
        rejected: () => this.handleRejected(),
      },
    );
  }

  disconnect() {
    clearTimeout(this.redirectTimer);
    clearTimeout(this.errorDelayTimer);
    this.cableSubscription?.unsubscribe();
  }

  handleReceived(data) {
    try {
      switch (data.status) {
        case 'success':
          this.redirectTimer = setTimeout(() => {
            window.location.href = data.next_step_path;
          }, this.delayValue);
          break;
        case 'failure':
          this.showErrorAfterDelay(this.step1FailureTarget);
          break;
        default:
          this.showErrorAfterDelay(this.step1ErrorTarget);
      }
    } catch (error) {
      console.error(
        'SubscriptionIntentionChannelController: error handling received data',
        error,
      );
      this.showErrorAfterDelay(this.step1ErrorTarget);
    }
  }

  handleRejected() {
    this.showErrorAfterDelay(this.step1ErrorTarget);
    this.cableSubscription?.unsubscribe();
  }

  showErrorAfterDelay(errorTarget) {
    this.errorDelayTimer = setTimeout(() => {
      this.step1Target.classList.add('d-none');
      errorTarget.classList.remove('d-none');
    }, this.delayValue);
  }
}
